/** Keeps `value` within `[min, max]`; `min` wins when the range is empty. */
export const clamp = (value: number, min: number, max: number): number =>
  Math.max(Math.min(value, max), min);
